import { render, staticRenderFns } from "./SkupPrijavaEdit.vue?vue&type=template&id=28e02b3a&scoped=true&"
import script from "./SkupPrijavaEdit.vue?vue&type=script&lang=js&"
export * from "./SkupPrijavaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e02b3a",
  null
  
)

export default component.exports